module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('router-link', {
    staticClass: "postLinkContainer",
    class: _vm.category,
    attrs: {
      "to": _vm.to
    }
  }, [_c('div', {
    staticClass: "info",
    class: _vm.categoryClasses(_vm.post)
  }, [_c('p', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.acf.displayDate, _vm.post.acf.displayDateEn))), (_vm.isNew) ? _c('span', {
    staticClass: "new"
  }, [_vm._v("NEW")]) : _vm._e()]), (!_vm.isEnglish && _vm.styledTitleJa) ? _c('h2', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.styledTitleJa)
    }
  }) : (_vm.isEnglish && _vm.styledTitleEn) ? _c('h2', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.styledTitleEn)
    }
  }) : _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.title.rendered, _vm.post.acf.titleEn)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46c272df!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/archive/posts/postLink.vue
// module id = 100
// module chunks = 1